import { createContext, useContext } from 'react';

import type {
  PageFooterButtonLabelMapByEvent,
  PageFooterButtonVariantMapByEvent,
  PageFooterContextParams,
} from './types';

const InitialPageFooterButtonVariantMapByEvent: PageFooterButtonVariantMapByEvent = {
  cancel: 'tertiary',
  close: 'tertiary',
  submit: 'primary',
  delete: 'danger',
  confirm: 'primary',
  common: 'primary',
};

const InitialPageFooterButtonLabelMapByEvent: PageFooterButtonLabelMapByEvent = {
  cancel: '취소',
  close: '닫기',
  submit: '적용',
  delete: '삭제',
  confirm: '확인',
  common: '확인',
};

const PageFooterContext = createContext<PageFooterContextParams>({
  variantMap: InitialPageFooterButtonVariantMapByEvent,
  labelMap: InitialPageFooterButtonLabelMapByEvent,
  loading: false,
});

const usePageFooterContext = () => useContext(PageFooterContext);

export {
  PageFooterContext,
  usePageFooterContext,
  InitialPageFooterButtonLabelMapByEvent,
  InitialPageFooterButtonVariantMapByEvent,
};
